import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngxs/store';
import { Borrower } from 'app/models/dto/borrower.model';
import { UpdateCall } from 'app/store/call/call.actions';
import { catchError, take } from 'rxjs';

@Component({
  selector: 'app-move-to-existing-business',
  templateUrl: './move-to-existing-business.component.html',
  styleUrls: ['./move-to-existing-business.component.scss'],
  standalone: false
})
export class MoveToExistingBusinessComponent implements OnInit {

  @Input() phoneNumber: number;
  @Output() callUpdated = new EventEmitter();

  selectedBusiness: Borrower;
  loading: boolean;
  error: boolean;

  constructor(private store: Store) { }

  ngOnInit(): void {}

  setSelectedBorrower(borrower: Borrower) {
    this.selectedBusiness = borrower;
  }

  updateCall() {
    this.loading = true;
    this.store.dispatch(new UpdateCall({ updatedBorrowerId: this.selectedBusiness.id })).pipe(
      take(1),
      catchError(err => {
        this.error = true;
        this.loading = false;
        throw err;
      })
    ).subscribe(() => {
      this.loading = false;
      this.callUpdated.emit();
    });
  }

  close() {
    this.callUpdated.emit();
  }

  dismissError() {
    this.error = false;
  }
}
